export default {
    Sample: {
        title: "Sample Help Section",
        items: [
            {
                title: "Sample Question?",
                body: [
                    { type: "plain", data: "Sample Description" },
                    { type: "list", data: ["Bullet Point 1", "Bullet Point 2"] },
                    { type: "image", data: "/sample.jpg" },
                    {
                        type: "video",
                        data: {
                            poster: "//vjs.zencdn.net/v/oceans.png",
                            mp4: "//vjs.zencdn.net/v/oceans.mp4",
                            mebm: "",
                            ogg: ""
                        }
                    },
                    { type: "html", data: "<b>BOLD<b>" }
                ]
            }
        ]
    },
    TOScan: {
        title: "Transfer Order Scan",
        items: [
        ]
    },
}
